import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const NOTIFICATIONS_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routesService: RoutesService) {
  return () => {
    routesService.add([
      {
        path: '/notifications',
        name: '::Notifications',
        iconClass: 'fas fa-envelope-open-text',
        order: 100,
        layout: eLayoutType.empty,
        requiredPolicy: 'Mandir.EmailTemplates',
      },
    ]);
  };
} 